import type {ReactElement} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import {LayoutButton} from '@Components/contextual-menu/components/layout-button';

export enum LayoutOptions {
  MENU = 'MENU',
  SCHEDULE = 'SCHEDULE',
}

interface ContextualMenuLayoutButtonProps {
  id: string;
  label: string;
  className?: string;
  layoutName: string;
  layoutFor: LayoutOptions;

  onClickButton(): void;
}

export function ContextualMenuLayoutButton({className = '', ...props}: ContextualMenuLayoutButtonProps): ReactElement<any> {
  return (
    <Option
      key={props.id}
      label={props.label}
      className={className}
      optionControl={
        <LayoutButton
          layoutFor={props.layoutFor}
          layoutName={props.layoutName}
          onClick={(): void => {
            props.onClickButton();
          }}
        />
      }
    />
  );
}
